import Navbar from './Navbar.view';

export default Navbar;
